import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import CloneDateForm from './CloneDateForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
class CloneDateDialog extends Component {
    constructor(props) {
        super(props);
    }

    dialogConfig() {
        const { t, onCancel, sourceDate } = this.props;

        return {
            header: t('WorkshopSession_CloneDate', { sourceDate: ui.formatDate(sourceDate) }),
            body: this.renderBody(),
            onHide: onCancel,
            footer: this.renderFooter()
        };
    }

    renderBody() {
        const { onConfirm, weekId, sourceDate } = this.props;
        return <CloneDateForm onSubmit={onConfirm} initialValues={{ weekId, sourceDate }} />;
    }

    renderFooter() {
        const { onCancel, t } = this.props;

        const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
        const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='cloneDate' label={t('Workshiop_Clone')} />;

        return [closeBtn, confirmBtn];
    }

    render() {
        const { show, block, unblock } = this.props;
        const dialogConfig = this.dialogConfig();
        return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
    }
}

CloneDateDialog.propTypes = {
    show: PropTypes.bool,
    to: PropTypes.array,
    block: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    unblock: PropTypes.oneOfType([
        PropTypes.instanceOf(RegExp),
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(CloneDateDialog);